import { ApiClient } from './swagger_client';

ApiClient.instance.basePath = process.env.REACT_APP_MONIBRAND_BACKEND_API_URL || ApiClient.instance.basePath;
